<nz-card [nzTitle]="titleTmpl" class="mt-2" *ngIf="show">
	<ng-template #titleTmpl>
		All Files
	</ng-template>
	<nz-upload *ngIf="!readonly"
		nzType="drag"
		[nzMultiple]="false"
		[nzCustomRequest]="customUpload"
		[nzShowUploadList]="false">
		<p class="ant-upload-drag-icon">
			<i nz-icon nzType="inbox" ></i>
		</p>
		<p class="ant-upload-text">Click or drag file to this area to upload</p>
	</nz-upload>
	<ngb-progressbar *ngIf="uploadProgress || uploadProgress == 0" class="mb-3" [showValue]="true" type="info" [value]="uploadProgress" />

	<div class="row">
		<div class="col-8">
			<nz-list>
				<ng-container *ngFor="let item of files; trackBy: trackByFields">
					<nz-list-item *ngIf="item.isAdditional == false">
						<nz-list-item-meta>
							<nz-list-item-meta-title>
								{{ item.name }}
							</nz-list-item-meta-title>
						</nz-list-item-meta>
						<nz-tag *ngIf="item.hasFile == true" nzColor="success">Uploaded</nz-tag>
						<nz-tag *ngIf="item.hasFile == false && (item.formControlWrapper?.element?.required??false) == true" nzColor="error">Required</nz-tag>
						<nz-tag *ngIf="item.hasFile == false && (item.formControlWrapper?.element?.required??false) == false" nzColor="warning">Not Uploaded</nz-tag>
						<button [disabled]="item.hasFile == false" nz-button nzSize="small" [nzType]="'dashed'" (click)="doPreviewFile(item)" class="me-2">
							<span nz-icon nzType="eye"></span>
						</button>
						<button [disabled]="item.hasFile == false" nz-button nzSize="small" [nzType]="'dashed'" (click)="doDownloadFile(item)" class="me-2">
							<span nz-icon nzType="download"></span>
						</button>
						<button [disabled]="item.hasFile == false" nz-button nzSize="small" nzType="default" nzDanger (click)="item.formControl.setValue(undefined)">X</button>
					</nz-list-item>
				</ng-container>
				<ng-container *ngFor="let item of files; trackBy: trackByFields">
					<nz-list-item *ngIf="item.isAdditional == true && item.isNew == false">
						<nz-list-item-meta>
							<nz-list-item-meta-title>
								{{item.name }}
							</nz-list-item-meta-title>
						</nz-list-item-meta>
						<nz-tag *ngIf="item.hasFile == true" nzColor="success">Uploaded</nz-tag>
						<nz-tag *ngIf="item.hasFile == false" nzColor="error">Required</nz-tag>
						<button [disabled]="item.hasFile == false" nz-button nzSize="small" [nzType]="'dashed'" (click)="doPreviewFile(item)" class="me-2">
							<span nz-icon nzType="eye"></span>
						</button>
						<button [disabled]="item.hasFile == false" nz-button nzSize="small" [nzType]="'dashed'" (click)="doDownloadFile(item)" class="me-2">
							<span nz-icon nzType="download"></span>
						</button>
						<button [disabled]="item.hasFile == false" nz-button nzSize="small" nzType="default" nzDanger (click)="item.formControl.setValue(undefined)">X</button>
					</nz-list-item>
				</ng-container>
				<ng-container *ngFor="let item of files; trackBy: trackByFields">
					<nz-list-item *ngIf="item.isAdditional == true && item.isNew == true">
						<nz-list-item-meta>
							<nz-list-item-meta-title>
								{{item.name }}
							</nz-list-item-meta-title>
						</nz-list-item-meta>
						<nz-tag *ngIf="item.hasFile == true" nzColor="success">Uploaded</nz-tag>
						<nz-tag *ngIf="item.hasFile == false" nzColor="warning">Not Uploaded</nz-tag>
						<button [disabled]="item.hasFile == false" nz-button nzSize="small" [nzType]="'dashed'" (click)="doPreviewFile(item)" class="me-2">
							<span nz-icon nzType="eye"></span>
						</button>
						<button [disabled]="item.hasFile == false" nz-button nzSize="small" [nzType]="'dashed'" (click)="doDownloadFile(item)" class="me-2">
							<span nz-icon nzType="download"></span>
						</button>
						<button nz-button nzSize="small" nzType="default" nzDanger (click)="removeAdditionalFile(item)">X</button>
					</nz-list-item>
				</ng-container>
			</nz-list>
			<button *ngIf="!readonly" nz-button [nzType]="'dashed'" (click)="addAdditionalFiles()">Add Additional File</button>
		</div>
	</div>
	<h5 class="mt-3">Uploaded in other steps</h5>
	<div class="row">
		<div class="col-8">
			<nz-list>
				<ng-container *ngFor="let item of ticket.filesFromOtherSteps; trackBy: trackByHash">
					<nz-list-item>
						<nz-list-item-meta>
							<nz-list-item-meta-title>
								{{ item.label }}
							</nz-list-item-meta-title>
						</nz-list-item-meta>
						<button [disabled]="item.canPreview == false" nz-button nzSize="small" [nzType]="'dashed'" (click)="doPreviewFile(item)" class="me-2">
							<span nz-icon nzType="eye"></span>
						</button>
						<button [disabled]="item.canDownload == false" nz-button nzSize="small" [nzType]="'dashed'" (click)="doDownloadFile(item)" class="me-2">
							<span nz-icon nzType="download"></span>
						</button>
					</nz-list-item>
				</ng-container>
			</nz-list>
		</div>
	</div>
</nz-card>


<ng-template #fileNameModal let-modal>
	<form [formGroup]="fileNameForm" class="p-3">
		<nz-form-item>
			<nz-form-label [nzSpan]="6" [nzRequired]="true">File Name</nz-form-label>
			<nz-form-control [nzSpan]="14">
				<nz-select nzMode="default" nzPlaceHolder="Select or type file names" formControlName="fileName" [nzOptions]="fileNameOptions">
				</nz-select>
			</nz-form-control>
		</nz-form-item>
	</form>
</ng-template>
<ng-template #newFileNameModal let-modal>
	<form [formGroup]="fileNameForm" class="p-3">
		<nz-form-item>
			<nz-form-label [nzSpan]="6" [nzRequired]="true">File Name</nz-form-label>
			<nz-form-control [nzSpan]="14">
				<input nz-input formControlName="fileName" placeholder="Enter file name" />
			</nz-form-control>
		</nz-form-item>
	</form>
</ng-template>
